import { useWindowDimensions } from 'react-native';

// Breakpoints for responsive design
export const BREAKPOINTS = {
  mobile: 0,
  tablet: 768,
  desktop: 1024,
  large: 1280,
};

export const useResponsive = () => {
  const { width } = useWindowDimensions();

  return {
    width,
    isMobile: width < BREAKPOINTS.tablet,
    isTablet: width >= BREAKPOINTS.tablet && width < BREAKPOINTS.desktop,
    isDesktop: width >= BREAKPOINTS.desktop,
    isLargeScreen: width >= BREAKPOINTS.large,
  };
};

export default useResponsive;
